import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { App, Project, SelectableField } from '../../models';

@Injectable({
    providedIn: 'root'
})
/* istanbul ignore file */
export class FieldsDataService extends HttpBaseService {

    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    getSelectableFields(app: App, project: Project): Observable<SelectableField[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/selectable-fields`;
        return this.httpGet(url);
    }

    getSummaryProjectSelectableFields(app: App, project: Project): Observable<SelectableField[]> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/selectable-fields`;
        return this.httpGet(url);
    }

    getSelectableFieldsAndGridFields(app: App, project: Project): Observable<SelectableField[]> {
        const url = `${this.route}${app.id}/projects/${project.id}/selectable-fields-and-grid-fields`;
        return this.httpGet(url);
    }

    getSummaryProjectSelectableFieldsAndGridFields(app: App, project: Project): Observable<SelectableField[]> {
        const url = `${this.route}${app.id}/summary-projects/${project.id}/selectable-fields-and-grid-fields`;
        return this.httpGet(url);
    }
}
